import { render, staticRenderFns } from "./contact-detail-main.vue?vue&type=template&id=69d946ce&"
import script from "./contact-detail-main.vue?vue&type=script&lang=js&"
export * from "./contact-detail-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports